import { Price } from "client/packages/commerce/components/ui/priceComponents/Price"
import {
  Attribute,
  Row,
  SubtotalWrapper,
} from "client/packages/commerce/components/ui/styles/SummaryStyles"
import { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"

import { getTotalCartCost, TargetCartContents } from "./TargetCartContext"

export const TotalsWrapper = styled.div`
  padding-bottom: 10px;
`

const TotalsRow = styled(Row)`
  margin: 5px 0;
  padding: 2px 0;
  font-family: "Target", Helvetica, sans-serif !important;
`

export type CartTotalsProps = {
  currencyCode: string
  cartContents: TargetCartContents
}

const CartTotals = ({ cartContents, currencyCode }: CartTotalsProps) => {
  const [subtotal, updateSubtotal] = useState(() =>
    getTotalCartCost(cartContents),
  )

  useEffect(() => {
    updateSubtotal(getTotalCartCost(cartContents))
  }, [cartContents])

  return (
    <TotalsWrapper>
      <SubtotalWrapper>
        <TotalsRow>
          <FormattedMessage
            id="cartTotals.shipping and taxes"
            defaultMessage="Taxes and shipping calculated at checkout"
          />
        </TotalsRow>
      </SubtotalWrapper>

      <TotalsRow>
        <Attribute>
          <FormattedMessage id="total" defaultMessage="Subtotal" />
        </Attribute>
        <Price
          amount={subtotal.toString()}
          currencyCode={currencyCode}
          showCurrencyCode={false}
        />
      </TotalsRow>
    </TotalsWrapper>
  )
}

export default CartTotals
